/* istanbul ignore file */
import { ReactElement, ReactNode } from 'react';
import { FloatingButtons } from '../../ui-builder';
import DefaultFormPageLayout, { DefaultFormPageLayoutProps } from '../form/FormPage/DefaultFormPageLayout';
import FormPageLayoutWithMenu from '../form/FormPage/FormPageLayoutWithMenu';

export interface FormPageLayoutProps extends Omit<DefaultFormPageLayoutProps, 'buttons'> {
  shouldScrollToErrorAfterLoading?: boolean;
  isCancelButtonVisible?: boolean;
  menu?: Nullable<ReactElement>;
  buttons?: ReactElement;
  titleActions?: ReactNode;
  onCancelAction?: () => void;
}

const FormPageLayout = ({
  shouldScrollToErrorAfterLoading = false,
  isCancelButtonVisible = true,
  menu = null,
  buttons,
  onCancelAction,
  ...props
}: FormPageLayoutProps) => {
  const resolvedButtons = buttons || (
    <FloatingButtons
      onCancelAction={onCancelAction}
      shouldScrollToErrorAfterLoading={shouldScrollToErrorAfterLoading}
      isCancelButtonVisible={isCancelButtonVisible}
    />
  );

  if (menu) return <FormPageLayoutWithMenu buttons={resolvedButtons} menu={menu} {...props} />;

  return <DefaultFormPageLayout buttons={resolvedButtons} {...props} />;
};

export default FormPageLayout;
